(function () {
  'use strict';
  var initialized = new WeakSet();
  function inputLabel(input) { return input.value || input.dataset.value || input.closest('li')?.getAttribute('value') || ''; }
  function inputs(wrapper) { return Array.from(wrapper?.querySelectorAll('input[type="radio"], [data-popout-option]') || []); }
  function unavailable(input) { return input.classList.contains('disabled') || input.classList.contains('unavailable') || input.getAttribute('aria-disabled') === 'true'; }
  function selected(input) { return input.checked || input.getAttribute('aria-current') === 'true'; }
  function activate(input) { if (input.matches('input')) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); } else input.click(); }
  function init(summary) {
    if (initialized.has(summary)) return; initialized.add(summary);
    var product = summary.closest('product-info'); var observer; var timer;
    function fallback(reason) {
      product?.classList.remove('is-size-summary-ready');
      var wrapper = product?.querySelector('[data-printmo-size-option]');
      wrapper?.removeAttribute('aria-hidden'); inputs(wrapper).forEach(function (input) { input.removeAttribute('tabindex'); });
      window.PrintmoProductPageMetrics?.emit('product_size_summary_fallback', { product_handle: summary.dataset.productHandle, reason: reason });
    }
    function sync() {
      var wrapper = product?.querySelector('[data-printmo-size-option]'); var choices = inputs(wrapper);
      if (!wrapper || !choices.length) { fallback('missing_native_size'); return; }
      var available = choices.filter(function (input) { return !unavailable(input); });
      var current = choices.find(selected);
      if (current && unavailable(current) && available.length) { activate(available[0]); return; }
      var list = summary.querySelector('[data-size-list]');
      list.replaceChildren.apply(list, choices.map(function (input, index) {
        var fragment = document.createDocumentFragment();
        if (index) fragment.append(document.createTextNode(' · '));
        var span = document.createElement('span'); span.dataset.sizeValue = inputLabel(input); span.textContent = inputLabel(input);
        if (unavailable(input)) { var note = document.createElement('small'); span.className = 'is-sold-out'; note.textContent = summary.dataset.soldOutLabel || 'Out of stock'; span.append(document.createTextNode(' '), note); }
        fragment.append(span); return fragment;
      }));
      var color = product?.querySelector('.printmo-native-color-selector input:checked')?.value || summary.dataset.colorName;
      var context = summary.querySelector('[data-size-context]');
      if (context && color) context.textContent = (summary.dataset.colorTemplate || 'Available in __COLOR__').replace('__COLOR__', color);
      wrapper.setAttribute('aria-hidden', 'true'); choices.forEach(function (input) { input.setAttribute('tabindex', '-1'); });
      product.classList.add('is-size-summary-ready');
      window.clearTimeout(timer);
    }
    observer = new MutationObserver(function (mutations) {
      var nativeSizeChanged = mutations.some(function (mutation) {
        if (mutation.target.closest?.('variant-selects')) return true;
        return Array.from(mutation.addedNodes || []).some(function (node) {
          return node.nodeType === 1 && (node.matches?.('[data-printmo-size-option], variant-selects') || node.querySelector?.('[data-printmo-size-option]'));
        });
      });
      if (nativeSizeChanged) sync();
    });
    observer.observe(product, { childList: true, subtree: true }); sync();
    if (typeof window.subscribe === 'function' && window.theme?.PUB_SUB_EVENTS) window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) {
      if (!product.contains(payload?.data?.event?.target)) return;
      window.clearTimeout(timer); timer = window.setTimeout(function () { fallback('update_timeout'); }, 10000);
    });
    var guide = summary.querySelector('[data-size-guide]');
    guide?.addEventListener('toggle', function () { if (guide.open) window.PrintmoProductPageMetrics?.emit('product_size_guide_open', { product_handle: summary.dataset.productHandle }); });
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-size-summary]').forEach(init); }
  document.addEventListener('theme:product-info:loaded', function (event) { boot(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
})();
